// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .box .select-materials {
  padding: 15% 5%;
}
.popup .box .select-materials h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
  line-height: 1.2em;
}
.popup .box .select-materials .items .row {
  overflow: hidden;
  margin-bottom: 8%;
}
.popup .box .select-materials .items .row .item {
  margin: 4% 1%;
  width: 48%;
  float: left;
}
.popup .box .select-materials .items .row .item h2 {
  margin-bottom: 8%;
}
.popup .box .select-materials .items .row .item .image {
  width: 100%;
  overflow: hidden;
  font: 1.7em/1 "vigaregular";
  border-radius: 8px;
  color: #caa36c;
  margin-bottom: 4%;
  background-size: cover;
}
.popup .box .select-materials .items .row .item .image::before {
  content: "";
  display: block;
  padding-bottom: 60%;
}
.popup .box .select-materials .items .row .item .image img {
  position: absolute;
  width: 100%;
  top: 0;
}
.popup .box .select-materials .items .row .item .description {
  text-align: center;
  font: 1.6em/1 "vigaregular";
  margin-top: 8%;
}
.popup .box .select-materials .items .row .item .description h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .box .select-materials .button a {
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  display: block;
  background-color: #caa36c;
}
.popup .box .select-materials .button.register {
  margin-top: 16%;
}
.popup .box .select-materials .button.register a {
  border: 2px solid #caa36c;
}
.popup .box .select-materials .button span {
  font: 1.9em/1 vigaregular;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/PublishMenuContent.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;AADZ;AAGY;EACI,uBAAA;EACA,cAAA;EACA,kBAAA;AADhB;AAKgB;EACI,gBAAA;EACA,iBAAA;AAHpB;AAKoB;EACI,aAAA;EACA,UAAA;EACA,WAAA;AAHxB;AAKwB;EACI,iBAAA;AAH5B;AAMwB;EACI,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AAJ5B;AAM4B;EACI,WAAA;EACA,cAAA;EACA,mBAAA;AAJhC;AAO4B;EACI,kBAAA;EACA,WAAA;EACA,MAAA;AALhC;AASwB;EACI,kBAAA;EACA,2BAAA;EACA,cAAA;AAP5B;AAS4B;EACI,uBAAA;EACA,cAAA;AAPhC;AAegB;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAbpB;AAgBgB;EACI,eAAA;AAdpB;AAeoB;EACI,yBAAA;AAbxB;AAiBgB;EACI,yBAAA;EACA,WAAA;AAfpB","sourcesContent":[".popup {\n    .box {\n        .select-materials {\n            padding: 15% 5%;\n\n            h2 {\n                font: 2em/1 vigaregular;\n                color: #5c5c5c;\n                line-height: 1.2em;\n            }\n\n            .items {\n                .row {\n                    overflow: hidden;\n                    margin-bottom: 8%;\n\n                    .item {\n                        margin: 4% 1%;\n                        width: 48%;\n                        float: left;\n\n                        h2 {\n                            margin-bottom: 8%;\n                        }\n\n                        .image { \n                            width: 100%;\n                            overflow: hidden;\n                            font: 1.7em/1 \"vigaregular\";\n                            border-radius: 8px;\n                            color: #caa36c;\n                            margin-bottom: 4%;\n                            background-size: cover;\n\n                            &::before {\n                                content: \"\";\n                                display: block;\n                                padding-bottom: 60%;\n                            }\n\n                            img {\n                                position: absolute;\n                                width: 100%;\n                                top: 0;\n                            }\n                        }\n\n                        .description {\n                            text-align: center;\n                            font: 1.6em/1 \"vigaregular\";\n                            margin-top: 8%;\n\n                            h2 {\n                                font: 2em/1 vigaregular;\n                                color: #5c5c5c;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .button {\n                a {\n                    text-decoration: none;\n                    text-align: center;\n                    border-radius: 5px;\n                    padding: 7% 0 7%;\n                    display: block;\n                    background-color: #caa36c;\n                }\n\n                &.register {\n                    margin-top: 16%;\n                    a {\n                        border: 2px solid #caa36c;\n                    }\n                }\n\n                span {\n                    font: 1.9em/1 vigaregular;\n                    color: #fff;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
